import _classCallCheck from "/home/catdrout/portfolio/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/home/catdrout/portfolio/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/catdrout/portfolio/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/catdrout/portfolio/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/catdrout/portfolio/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Info } from './info.js';
import * as types from './types.js';
var checks = Object.keys(types);
export var DefinedInfo = /*#__PURE__*/function (_Info) {
  _inherits(DefinedInfo, _Info);

  var _super = _createSuper(DefinedInfo);

  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number} [mask]
   * @param {string} [space]
   */
  function DefinedInfo(property, attribute, mask, space) {
    var _this;

    _classCallCheck(this, DefinedInfo);

    var index = -1;
    _this = _super.call(this, property, attribute);
    mark(_assertThisInitialized(_this), 'space', space);

    while (++index < checks.length) {
      mark(_assertThisInitialized(_this), checks[index], (mask & types[checks[index]]) === types[checks[index]]);
    }

    return _this;
  }

  return DefinedInfo;
}(Info);
DefinedInfo.prototype.defined = true;
/**
 * @param {InstanceType<typeof DefinedInfo>} values
 * @param {string} key
 * @param {unknown} value
 */

function mark(values, key, value) {
  if (value) {
    values[key] = value;
  }
}